import React from 'react';
import { Success } from 'common';

const SignUpSuccessPage = () => {
  return (
    <Success
      header={
        'You have successfully created a mortgage application login. Please use your email as your username. Click login to proceed to your application'
      }
      href={'/mortgage/sign-in'}
    />
  );
};

export default SignUpSuccessPage;
